import { HttpMethods, makeRequest } from "../helpers/http.helper";
import type {
  EsgBranchWasteExportResponse,
  EsgDashboardByBranchResponse,
  EsgDashboardPersona,
  EsgMonthQuery,
} from "../types/esg-dashboard.type";

function esgBasePath(persona: EsgDashboardPersona, organizationId: string): string {
  return `/dashboard/esg/${persona}/${organizationId}`;
}

export function getEsgDashboardByBranch(
  persona: EsgDashboardPersona,
  organizationId: string,
  monthQuery: EsgMonthQuery,
): Promise<EsgDashboardByBranchResponse> {
  return makeRequest({
    url: `${esgBasePath(persona, organizationId)}/by-branch`,
    method: HttpMethods.GET,
    params: monthQuery,
  });
}

/** Full-history data (all branches, all months) backing the branch waste xlsx export. */
export function getEsgBranchWasteExport(
  persona: EsgDashboardPersona,
  organizationId: string,
): Promise<EsgBranchWasteExportResponse> {
  return makeRequest({
    url: `${esgBasePath(persona, organizationId)}/by-branch/export`,
    method: HttpMethods.GET,
  });
}
